import paytable from './paytable';
import ajs from './ajs';
import ticketsHistory from './ticketsHistory';
import ticketCheck from './ticketCheck';

export default {
  paytable,
  ajs,
  ticketsHistory,
  ticketCheck,
};
